import React from 'react'
import { ConfigProvider, Flex } from 'antd'
import DomainSettingsTab, {
    IDomainSettingsTab,
    IDomainSettingsTabState,
} from '../abstract-domain-settings-tab/abstract-domain-settings-tab'
import { BrandVoiceWell } from './brand-voice-well'
import { AbilityAction } from '../../enums/ability-action.enum'
import { VERTICAL_WELL_GAP } from '../../theme/constants'
import { getClassNames } from '../../_utils/classnames'

interface IDomainAiSettings extends IDomainSettingsTab {}

interface IState extends IDomainSettingsTabState {}

class DomainAiSettings extends DomainSettingsTab<IDomainAiSettings, IState> {
    public render() {
        const { domain } = this.state
        const canEdit = !!domain && this.appState.abilityStore.can(AbilityAction.UPDATE, domain)

        return (
            <Flex vertical gap={VERTICAL_WELL_GAP} className={getClassNames('domain-ai-settings')}>
                <ConfigProvider
                    theme={{
                        components: {
                            Form: {
                                itemMarginBottom: 4,
                                labelColor: 'var(--ant-color-secondary)',
                            },
                        },
                    }}
                >
                    <BrandVoiceWell domainId={this.props.domainId} canEdit={canEdit} />
                </ConfigProvider>
            </Flex>
        )
    }
}

export default DomainAiSettings
